import { Box, MenuItem, TextField, Typography } from '@mui/material';
import ConditionCriteriaFields from './ConditionCriteriaFields';

// Settings for the "Bedingung" block: the shared criteria plus what happens when
// the condition is not met. Stays on a single path — use the "Bedingter Split"
// block when the flow should branch into two separate paths.
const ConditionSettings = ({ block, blocks = [], readOnly, onConfigChange }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <ConditionCriteriaFields
      block={block}
      blocks={blocks}
      readOnly={readOnly}
      onConfigChange={onConfigChange}
    />
    <TextField
      select
      size='small'
      label='Wenn Bedingung nicht erfüllt'
      value={block.config?.failAction || 'skipNext'}
      disabled={readOnly}
      onChange={event => onConfigChange({ failAction: event.target.value })}
    >
      <MenuItem value='skipNext'>Nächsten Block überspringen</MenuItem>
      <MenuItem value='exit'>Flow für den Kontakt beenden</MenuItem>
    </TextField>
    <Typography variant='caption' color='text.secondary'>
      Erfüllt der Kontakt die Bedingung, läuft der Flow normal weiter. Andernfalls wird je nach
      Einstellung der direkt folgende Block übersprungen oder der Kontakt verlässt den Flow.
    </Typography>
  </Box>
);

export default ConditionSettings;
